import $ from 'jquery';

const initStickyMobileAddToCart = function() {
  const mobileSizesSelector = '.en_mdl_article_sticky_mobile_sizes';
  const mobileSizeSelector = '.en_mdl_article_sticky_mobile_sizes__size';
  const mobileSizesInnerSelector = '.en_mdl_article_sticky_mobile_sizes__sizes_inner';
  const mobileSizesInner = document.querySelector( mobileSizesInnerSelector );
  const mobileFakeSelectSelector = '.en_mdl_article_detail__sticky_mobile_fake_select';
  const sizeRadioSelector = '#size_select_wrapper .en_mdl_article_detail__size-choice input[type="radio"]';
  let isOpen = false;

  cloneSizesForSticky();
  $( document ).on( 'article_detail_reload.en', function() {
    cloneSizesForSticky();
  } );

  document.addEventListener( 'change', e => {
    let choiceEl = e.target;
    if( !choiceEl.parentNode.classList.contains( 'en_mdl_article_detail__size-choice' ) ) return;
    document.querySelector( mobileFakeSelectSelector ).textContent = choiceEl.nextElementSibling.textContent;
    document.querySelectorAll( mobileSizeSelector ).forEach( size => {
      size.classList.remove( 'is_selected' );
      if( size.dataset.value === choiceEl.value ) {
        size.classList.add( 'is_selected' );
      }
    } );
  } );

  document.addEventListener( 'click', e => {
    let elem = e.target;
    while( elem.parentNode.tagName != 'HTML' ) {
      if( elem.matches( mobileSizeSelector ) ) {
        document.querySelectorAll( sizeRadioSelector ).forEach( sizeRadio => {
          if( elem.dataset.value === sizeRadio.value ) {
            sizeRadio.checked = true;
            sizeRadio.dispatchEvent( new Event( 'change', { bubbles: true, cancelable: false } ) )
          }
          closeMobileSizes();
        } );
        return;
      }
      elem = elem.parentNode;
    }
  } );

  document.querySelector( '.en_js_open_mobile_sizes' ).addEventListener( 'click', e => {
    e.preventDefault();
    openMobileSizes();
  } );

  document.querySelector( '.en_js_close_mobile_sizes' ).addEventListener( 'click', e => {
    e.preventDefault();
    closeMobileSizes();
  } );

  document.addEventListener( 'click', e => {
    let close = true;

    let elem = e.target;
    while( elem.parentNode.tagName != 'HTML' ) {
      if( elem.matches( mobileSizesSelector ) || elem.matches( '.en_mdl_article_detail__sticky_mobile' ) ) {
        close = false;
      }
      elem = elem.parentNode;
    }

    if( close && isOpen ) {
      closeMobileSizes();
    }
  } );

  function openMobileSizes() {
    scrollLock.disablePageScroll( mobileSizesInner );
    document.querySelector( mobileSizesSelector ).classList.add( 'is-active' );
    isOpen = true;
  }

  function closeMobileSizes() {
    scrollLock.enablePageScroll( mobileSizesInner );
    document.querySelector( mobileSizesSelector ).classList.remove( 'is-active' );
    isOpen = false;
  }
}

const cloneSizesForSticky = function() {
  const mobileSizesInnerSelector = '.en_mdl_article_sticky_mobile_sizes__sizes_inner';
  const mobileSizesInner = document.querySelector( mobileSizesInnerSelector );
  const buttonMobileGriditemSelector = '.en_mdl_article_detail__button_mobile_griditem';
  const buttonMobileGriditem = document.querySelector( buttonMobileGriditemSelector );

  const stickyAddToBasketButton = document.querySelector( '.en_mdl_article_detail__buttons .en_mdl_article_detail__button' ).cloneNode( true );
  if( stickyAddToBasketButton.innerHTML === 'Bei Verfügbarkeit erinnern' ) {
    stickyAddToBasketButton.innerHTML = 'Benachrichtigen';
  }

  buttonMobileGriditem.innerHTML = '';
  buttonMobileGriditem.appendChild( stickyAddToBasketButton );

  if( document.getElementById( 'size_select_wrapper' ) ) {
    document.querySelector( '.en_mdl_article_detail__sticky_mobile_fake_select_griditem' ).classList.remove( 'en_hidden' );
  }

  mobileSizesInner.innerHTML = '';

  document.querySelectorAll( '.en_mdl_article_detail__size-choice .en_button--choice' ).forEach( ( choice ) => {
    const input = choice.previousElementSibling;

    if( input.checked ) {
      document.querySelector( '.en_mdl_article_detail__sticky_mobile_fake_select' ).textContent = choice.textContent;
    }

    let mobileSize = document.createElement( 'div' );
    mobileSize.className = 'en_mdl_article_sticky_mobile_sizes__size' + ( input.checked ? ' is_selected' : '' ) + ( choice.classList.contains( 'en_button--disabled' ) ? ' is_soldout' : '' );
    mobileSize.dataset.value = input.value;

    let mobileSizeInner = document.createElement( 'div' );
    mobileSizeInner.className = 'en_mdl_article_sticky_mobile_sizes__size_value';
    mobileSizeInner.textContent = choice.textContent;

    mobileSize.appendChild( mobileSizeInner );

    if( choice.classList.contains( 'en_button--disabled' ) ) {
      let mobileSizeSoldout = document.createElement( 'div' );
      mobileSizeSoldout.className = 'en_mdl_article_sticky_mobile_sizes__size_info';
      mobileSizeSoldout.textContent = 'Ausverkauft';
      mobileSize.appendChild( mobileSizeSoldout );
    } else if( choice.classList.contains( 'en_button--notavailable' ) ) {
      let mobileSizeNotAvailable = document.createElement( 'div' );
      mobileSizeNotAvailable.className = 'en_mdl_article_sticky_mobile_sizes__size_info';
      mobileSizeNotAvailable.innerHTML = '<span class="en_icon en_icon--inline" data-en-icon="mail_outline"></span>Bei Verfügbarkeit erinnern</div>';
      mobileSize.appendChild( mobileSizeNotAvailable );
    }

    mobileSizesInner.appendChild( mobileSize );
  } );
}

$( document ).ready( function() {
  initStickyMobileAddToCart();
} );
